import React, { useEffect, useState } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerPendingListRead({ onSelect, selectedId, interactive = true, refreshToken }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');


  const fetchPending = async (p = 1) => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/influencer/pending-read?page=${p}&limit=50`,{
        credentials: 'include' 
      });
      if (res.status === 401) {
        setError('관리자 세션이 만료되었습니다. 다시 로그인하세요.');
        setItems([]);
        return;
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || '불러오기 실패');
      setItems(data.items || []);
    } catch (e) {
      setError(e.message || '불러오기 실패');
    }
    setLoading(false);
  };

  useEffect(() => { fetchPending(1); }, [refreshToken]);

  const fmt = (d) => {
    try { return new Date(d).toLocaleDateString(); } catch { return d || ''; }
  };

  return (
    <div className="admin-list">
      <div className="admin-list__header">가입 승인</div>
      
      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && (
          <div className="admin-list__empty">승인 대기 중인 가입 요청이 없습니다.</div>
        )}

        {!loading && items.length > 0 && (
          <div>
            {items.map((u) => (
              <div
                key={u._id || u.userId}
                onClick={interactive && onSelect ? () => onSelect(u) : undefined}
                className={`admin-list__item ${
                  selectedId && (selectedId === (u._id || u.userId)) ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {u.userId} ({u.userName})
                  </div>
                  <div className="admin-list__item-sub">{fmt(u.registeredAt)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerPendingListRead;
